import { QueryClient } from '@tanstack/react-query';
import { PlanningsTruckEntity } from 'src/entities/PlanningsTruck.entity';
import { TruckEntity } from 'src/entities/Truck.entity';

/**
 * useQueryPlanningsTrucksのキャッシュを管理するクラス
 */
export class PlanningsTrucksCache {
  // eslint-disable-next-line no-useless-constructor
  constructor(private queryClient: QueryClient) {}

  /**
   * トラックを追加する
   */
  addTrucks(trucks: TruckEntity[]): void {
    const trucksCache = this.queryClient.getQueriesData(['useQueryPlanningsTrucks']);
    trucksCache.forEach(([queryCacheKey, cacheData]) => {
      if (cacheData && Array.isArray(cacheData)) {
        const typedCacheData = cacheData as TruckEntity[];
        this.queryClient.setQueryData(queryCacheKey, [...typedCacheData, ...trucks]);
      }
    });
  }

  /**
   * 指定されたIDのトラックを削除する
   */
  removeTruckById(truckId: number): void {
    const trucksCache = this.queryClient.getQueriesData(['useQueryPlanningsTrucks']);
    trucksCache.forEach(([queryCacheKey, queryData]) => {
      if (queryData && Array.isArray(queryData)) {
        const updatedTrucks = queryData.filter((cache) => {
          const truck = cache as unknown as PlanningsTruckEntity;
          return truck.id !== truckId;
        });
        this.queryClient.setQueryData(queryCacheKey, updatedTrucks);
      }
    });
  }
}
